import {
    ComponentParams,
    ComponentRendering,
    Placeholder,
} from "@sitecore-jss/sitecore-jss-nextjs";
import { Accordion as ChakraAccordion } from "@chakra-ui/react";
import GenericHeader, { GenericHeaderProps } from "components/ui/GenericHeader";

export type AccordionProps = {
    rendering: ComponentRendering & { params: ComponentParams };
    params: { [key: string]: string };
    fields: Fields;
};

interface Fields extends GenericHeaderProps {
    fields: Fields;
}

const Accordion = (props: AccordionProps) => {
    const phKey = `Accordion-${props.params?.DynamicPlaceholderId}`;
    return (
        <GenericHeader
            Id={props.rendering?.uid}
            HeaderHeadline={props.fields?.HeaderHeadline}
            HeaderSubHeadline={props.fields?.HeaderSubHeadline}
            HeaderCTA={props.fields?.HeaderCTA}
            headlineSize={props.params?.HeaderHeadlineSize}
        >
            <ChakraAccordion
                variant="ContentAccordion"
                sx={{ counterReset: "line-number" }}
                allowToggle
            >
                <Placeholder name={phKey} rendering={props.rendering} />
            </ChakraAccordion>
        </GenericHeader>
    );
};
export default Accordion;
